import React, { Component, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import TelcoSite from '../../../ducks/TelcoSite';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import editIcon from '../../../assets/img/ic_edit.png';
import trash_bin from '../../../assets/img/trash_bin.png';
import { Spinner , WhiteSpinner } from '../../common/Spinner';
import TextFieldGroup from '../../common/TextFieldGroup';
import searchIcon from '../../../assets/img/ic_search.png';
import Modal from 'react-bootstrap4-modal';
import toastr from 'toastr';
import '../index.css';

const TelcoSiteTable = (props) => {
    const [search , setSearch] = useState("")
    const [geoFenceToBeDeleted , setgeoFenceToBeDeleted] = useState()
    const [showDeleteConfirmation , setshowDeleteConfirmation] = useState(false)
    const [deletingGeofence , setdeletingGeofence] = useState(false)

    const updateGeoFence = (item) => {
        console.log("called")
        props.history.push(`/updateTelcosite/${item._id}`);

    }

    const showDeleteGeoFenceConfirmation = (item) => {
        setgeoFenceToBeDeleted(item);
        setshowDeleteConfirmation(true)
       
      };
    
      const deleteGeoFence = async () => {
        if (!deletingGeofence) {
           setdeletingGeofence(true)
          await 
            props
            .actions
            .deleteSite({ id: geoFenceToBeDeleted._id});
    
          toastr.success("Geofence deleted successfully!");
          setdeletingGeofence(false);
          setshowDeleteConfirmation(false);
          window.location.reload();
          
        }
      }

    const searchGeofence = async (e) => {
        e.preventDefault();
        const value = search;
        setSearch(value)
        loadGeofences(true);
    }
    const onChange = (event) => {
        const value = event.target.value || '';
        setSearch(value);
      
        if (!value) {
          loadGeofences(true);
        }
      };

    

    const loadGeofences = async (initLoad) => {
        await props.actions.getPaginatedSites(search, initLoad);
        
      }

    const cancelDelete = () => {
        setshowDeleteConfirmation(false)
      }

    useEffect(() => {
        loadGeofences(true)
    }, [])

    const loader = <Spinner key='1' />
    const smallLoader = <WhiteSpinner key="1" />
    return (
        <div className='row'>
            {showDeleteConfirmation ?
          <Modal
            visible={true}
            dialogClassName='delete-modal-dialog'>
            <div>
              <button
                type='button'
                className='close close-x'
                aria-label='Close'
                onClick={()=>{
                    cancelDelete()
                }}>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-heading'>
              <h5 className='car-and-device-assig'>Delete TelcoSite?</h5>
            </div>
            <div className='modal-body'>
              <h6>Are you sure you want to delete TelcoSite {geoFenceToBeDeleted.name}?</h6>


            </div>
            <div className='modal-footer model-btn'>
              <button
                className='btn auxo-primary-btn'
                onClick={()=>{
                    deleteGeoFence()
                }}>
                {deletingGeofence ? [smallLoader] : 'Confirm Delete'}
              </button>

              <button
                className='btn auxo-primary-btn'
                onClick={()=>{
                    cancelDelete()
                }}>
                Cancel
                    </button>
            </div>
          </Modal>
          : ''}
          <div className='col-lg-3 col-md-3 col-sm-4 margin-top-20'>
            <form onSubmit={searchGeofence}>
              <TextFieldGroup
                field={"tsearch"}
                placeholder={"Search Sites"}
                value={search}
                onChange={onChange}
                type={'text'}
                 />
              <a onClick={searchGeofence} className='search-icon' ><img  src={searchIcon} alt='' /></a>
            </form>
          </div>
          <div className='col-lg-2 col-md-2 col-sm-2 margin-top-20'>
        <div className="geofenceCount">Total Sites: {props.siteCount}</div>
        </div>
            <InfiniteScroll
                className="w-100-p"
                pageStart={0}
                loadMore={()=>{loadGeofences(false)}}
                hasMore={props.hasMoreItems}
                loader={loader}
            >

                <div className='trip-table-heading'>
                    <p className='width-20'>Telcosite</p>
                    <p className='width-20'>Description</p>
                    <p className='width-20'>Lat/Lng</p>
                    <p className='width-20'>LOCATION</p>
                    <p className='width-20'>ACTIONS</p>
                </div>
                {props.sites.map((item, index) => {

                    return (

                        <div className='width-100' key={index}>
                            <div className='trip-table-data'>

                                <p className='width-20'>

                                    {/* <a id={`${index}`} className='trip-date width-10' onClick={this.openGeofence.bind(this, item._id)}>
                                            <img className={item.isSelected ? 'list-view-transform width18' : 'width18'}  alt='' src={forwardIcon} />
                                        </a> */}
                                    {item.name}
                                </p>
                                <p className='width-20'>
                                    {item.description}
                                </p>
                                <p className='width-20'>{item.center[0]}{","}{item.center[1]}</p>
                                <p className='width-20'>{item.geoFenceLocation}</p>

                                {/* <p className='width-20'>{`${item.vehicles.length} Vehicles`} </p> */}


                                <span>

                                    <a className='padding-10' onClick={
                                        ()=>{
                                            updateGeoFence(item)
                                        }
                                        } ><img src={editIcon} alt='' /></a>

                                    <a onClick={()=>{
                                        showDeleteGeoFenceConfirmation(item)
                                    }} ><img src={trash_bin} className='width16' alt='' /></a>
                                </span>
                            </div>

                        </div>

                    )
                })}



            </InfiniteScroll>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        sites: state.telcosites.sites,
        hasMoreItems: state.telcosites.hasMoreItems,
        siteCount: state.telcosites.siteCount
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(TelcoSite.creators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TelcoSiteTable)
